// extracted by mini-css-extract-plugin
export var revs = "style-module--revs--f00b0";
export var swiperButtonNext = "style-module--swiper-button-next--2646b";
export var swiperButtonPrev = "style-module--swiper-button-prev--f41b2";
export var swiperButtons = "style-module--swiper-buttons--c4e17";